import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CarIcon, GasPump, ViewExpendIcon } from '../../icons';
import { useServiceCarStore } from '../../store/serviceCarStore';
import { checkBookingEnabled, checkDriverManage } from '../../utils/helper';
import BookAServiceInfoModal from '../elements/bookAServiceInfoModal';
import DriverForm from '../drivers/driverForm';
import { CustomModal } from '../ui';
import { useAssignDrivers } from '../../hooks/react-query/useDrivers';
import { queryClient } from '../../utils/queryClient';
import { QUERY_KEYS } from '../../config/constants';
import { DialogClose } from '@radix-ui/react-dialog';

const { DRIVERS } = QUERY_KEYS;

const CarOverView = ({ selectedCar, handleViewState, handleAssignClick, hasDrivers, isAdmin}) => {
  const [addDriverModal,setAddDriverModal] = useState(false)
  const { ModelId, EndDate, FuelType, ModelName, MakeName, plateno, actions, Color, VIN, CreditFacilityCode } =
    selectedCar || {};

  const isDriverManage = checkDriverManage(actions);

  const isBookingEnabled = checkBookingEnabled(actions);

  const navigate = useNavigate();
  const { setCarInfo } = useServiceCarStore();
  const { mutate: assignDriver } = useAssignDrivers();

  const handleAssignDriver = (id) => {
    assignDriver(
      { plateno: plateno, id: id},
      {
          onSuccess: (data) => {
              queryClient.invalidateQueries({
                queryKey: [DRIVERS, plateno],
              });
        },
      }
    );
  };

  return (
    <div className='flex flex-col h-[645px] p-6 bg-white rounded-lg'>
      {(!plateno && !isDriverManage ) && <div className='flex h-full items-center justify-center text-center font-semibold'> 
        Επίλεξε ένα αυτοκίνητο για να δεις αναλυτικά στοιχεία.
        </div>}
      <div className="flex flex-col gap-y-14 ">
        { !!plateno && (
          <button
          type="button"
          className="flex gap-2"
          onClick={handleViewState}
          disabled={!plateno}
        >
          <ViewExpendIcon />
          <span className="text-label">Αναλυτικά στοιχεία</span>
        </button>
        )}
        {ModelId && (
          <div className="flex flex-col gap-4">
            <h3>{MakeName}</h3>
            <div className="flex flex-col gap-2">
              <div className="flex gap-3">
                <GasPump /> <span className="text-body">{FuelType}</span>
              </div>
              <div className="flex gap-3">
                <CarIcon color="black" />{' '}
                <span className="text-body">{ModelName}</span>
              </div>
            </div>
            <div className="">
              <span className="text-label text-fadedgrey">
              Ημερ/νία λήξης συμβολαίου
              </span>
              <div className="text-body">{EndDate.split('-')[2] +'/'+ EndDate.split('-')[1] +'/'+ EndDate.split('-')[0]}</div>
            </div>
            <div className="">
              <span className="text-label text-fadedgrey">
              Χρώμα
              </span>
              <div className="text-body">{Color}</div>
            </div>
            <div className="">
              <span className="text-label text-fadedgrey">
              VIN
              </span>
              <div className="text-body">{VIN}</div>
            </div>
            <div className="">
              <span className="text-label text-fadedgrey">
              Αριθμός παραρτήματος
              </span>
              <div className="text-body">{CreditFacilityCode}</div>
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-3 mt-auto items-center">
        {isBookingEnabled ? (
          <button
            disabled={!plateno && !isAdmin}
            onClick={() => {
              navigate('/service-booking');
              setCarInfo(selectedCar);
            }}
            className="btn-secondary text-secondary-button w-full "
          >
            Ραντεβού Service
          </button>
        ) : <BookAServiceInfoModal fullWith={true} disabled={!plateno && !isAdmin} />
        }
        {(isAdmin === false) && <button
          disabled={!isDriverManage && !plateno}
          type="button"
          className="btn-secondary text-secondary-button w-full"
          onClick={handleAssignClick}
        >
          Προσθήκη Οδηγού
        </button>
        }
        {(isAdmin === false) && <CustomModal
            disabled={!isDriverManage && !plateno}
              triggerComponent={
                <p className={`${(!plateno) ? 'border border-fadedgrey rounded-md w-full py-3 px-6 text-secondary-button text-fadedgrey' : 'btn-secondary text-secondary-button w-full px-[24px]'}`} >
                  Καταχώριση Νέου Οδηγού
                </p> 
              }
              wrapperClass="grid"
              handleClick={(value) => setAddDriverModal(value)}
              openModal={addDriverModal}
            >
              <div className="container-sm mx-auto lg:py-10 py-5 flex flex-col items-center gap-y-5 max-lg:px-5 max-h-screen overflow-y-auto">
                <div className="flex flex-col gap-10">
                  <h3 className="text-center">Καταχώριση νέου οδηγού</h3>
                  {/* =============== NEW ================ */}
                  {!hasDrivers && <p className="text-center px-10"> Ο οδηγός που θα καταχωρίσεις θα δηλωθεί αυτόματα και ως κύριος οδηγός του αυτοκινήτου.<br />Στη συνέχεια, μπορείς να αλλάξεις τον κύριο οδηγό οποιαδήποτε στιγμή.</p>}
                  {/* ============== NEW ================= */}
                  <DriverForm
                    mode="create"
                    btnText="Αποθήκευση"
                    handleClose={(id) => {handleAssignDriver(id); setAddDriverModal(false)}}
                  />
                </div>
              </div>
            </CustomModal>
            }
      </div>
    </div>
  );
};

export default CarOverView;
